import { render, staticRenderFns } from "./_user-management.vue?vue&type=template&id=0de1c244"
import script from "./_user-management.vue?vue&type=script&lang=js"
export * from "./_user-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports